export default "__VITE_ASSET__CCcRafOK__"